/**
 * API service — Reporte de Auditoría
 * Endpoint: GET /api/sistema/reporte-auditoria/
 */

const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:8000/api';

function getAuthHeaders() {
  const token = localStorage.getItem('authToken');
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}

/**
 * Consulta la bitácora de auditoría con filtros y paginación.
 *
 * @param {Object} params
 * @param {string} [params.nombre_usuario]
 * @param {string} [params.modulo]
 * @param {string} [params.tabla]
 * @param {string} [params.pantalla]
 * @param {string} [params.tipo_operacion]
 * @param {string} [params.fecha_desde]  — YYYY-MM-DD
 * @param {string} [params.fecha_hasta]  — YYYY-MM-DD
 * @param {number} [params.page]
 * @param {number} [params.page_size]
 * @returns {Promise<{ total, page, page_size, total_pages, resultados: Array }>}
 */
export async function getReporteAuditoria(params = {}) {
  const qp = new URLSearchParams();
  if (params.nombre_usuario) qp.set('nombre_usuario', params.nombre_usuario);
  if (params.modulo) qp.set('modulo', params.modulo);
  if (params.tabla) qp.set('tabla', params.tabla);
  if (params.pantalla) qp.set('pantalla', params.pantalla);
  if (params.tipo_operacion) qp.set('tipo_operacion', params.tipo_operacion);
  if (params.fecha_desde) qp.set('fecha_desde', params.fecha_desde);
  if (params.fecha_hasta) qp.set('fecha_hasta', params.fecha_hasta);
  if (params.page) qp.set('page', params.page);
  if (params.page_size) qp.set('page_size', params.page_size);
  if (params.no_pagination) qp.set('no_pagination', 'true');

  const url = `${API_BASE}/sistema/reporte-auditoria/?${qp.toString()}`;
  const resp = await fetch(url, { headers: getAuthHeaders() });

  if (!resp.ok) {
    const text = await resp.text().catch(() => '');
    throw new Error(`Error ${resp.status}: ${text}`);
  }
  return resp.json();
}

/**
 * Obtiene la lista de módulos disponibles para el dropdown del filtro
 * del reporte de auditoría.
 *
 * @returns {Promise<{ modulos: string[] }>}
 */
export async function getModulosAuditoria() {
  const url = `${API_BASE}/sistema/auditoria/modulos/`;
  const resp = await fetch(url, { headers: getAuthHeaders() });
  if (!resp.ok) {
    return { modulos: [] };
  }
  return resp.json();
}

/**
 * Obtiene la lista de pantallas (rutas) registradas en la bitácora.
 * Si se pasa `modulo`, filtra únicamente las pantallas de ese módulo.
 *
 * @param {string} [modulo]
 * @returns {Promise<{ pantallas: string[] }>}
 */
export async function getPantallasAuditoria(modulo = '') {
  const qp = new URLSearchParams();
  if (modulo) qp.set('modulo', modulo);
  const url = `${API_BASE}/sistema/auditoria/pantallas/?${qp.toString()}`;
  const resp = await fetch(url, { headers: getAuthHeaders() });
  if (!resp.ok) {
    return { pantallas: [] };
  }
  return resp.json();
}
